import "moment/locale/fr";

import moment from "moment";

moment.locale("fr");

const Moment = moment;

export default Moment;
